<template>
    <div>
        <div class="d-flex">
            <SideNav parent="profile" :isVisibleShowAccount.sync="showAccount" />
            <div class="selected-nav">
                <ProfileSettings :isVisibleShowAccount.sync="showAccount" v-if="showAccount" />
            </div>
        </div>
    </div>
</template>
<script>
    import SideNav from '@/components/parts/SideNav.vue'
    import ProfileSettings from './ProfileSettings.vue'
    export default {
        name: 'Profile',
        components: {
            SideNav,
            ProfileSettings
        },
        data: () => ({
            showAccount: false
        })
    }
</script>
<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .selected-nav {
        margin-left: 40px;
        flex: 50%;
    }
</style>
